import { render, staticRenderFns } from "./Asset-Modify.vue?vue&type=template&id=66bba189"
import script from "./Asset-Modify.vue?vue&type=script&lang=js"
export * from "./Asset-Modify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports